import flatten from 'flat';
import { set } from 'dot-prop';
export { get } from 'dot-prop';
export { set } from 'dot-prop';
/**
 * @function assign
 * @since 1.0.0
 */
export function assign(object, key, value) {
    object[key] = value;
    return object;
}
/**
 * @function nest
 * @since 1.0.0
 */
export function nest(values) {
    const nested = {};
    const object = Object.assign({}, values);
    Object.entries(object).forEach(([key, val]) => set(nested, key, val));
    return nested;
}
/**
 * @function flat
 * @since 1.0.0
 */
export function flat(object) {
    return flatten(object);
}
